import Swiper from 'swiper/bundle';
import 'swiper/css';
import 'swiper/css/pagination';

export default {
    name : 'swiper-banner',

    init()
    {
        const items = document.querySelectorAll('.swiper--banner');
        if (items.length) {
            setTimeout(this.run, 100);
        }
    },
    run ()
    {
        const collections = document.querySelectorAll('.swiper--banner');

        if (!collections) {
            return false;
        }

        const sliderIds = [];
        collections.forEach( (element) => sliderIds.push(element.id));

        const sliders = [];

        if (sliderIds.length) {
            for (let i=0; i<sliderIds.length;i++) {
                sliders[i] = new Swiper('#'+sliderIds[i] , {
                        spaceBetween: 0,
                        slidesPerView: 1,

                        pagination: {
                            el: ".swiper-pagination",
                            clickable: true
                        },
                        autoplay: {
                            delay: 10000,
                            disableOnInteraction: false
                        },
                        // on: {
                        //     autoplayTimeLeft(s, time, progress) {
                        //         progressCircle.style.setProperty("--progress", 1 - progress);
                        //         progressContent.textContent = `${Math.ceil(time / 1000)}s`;
                        //     }
                        // },
                        // navigation: {
                        //     nextEl: '#'+sliderIds[i]+ " .swiper-button-next",
                        //     prevEl: '#'+sliderIds[i] + " .swiper-button-prev",
                        // },
                    }
                );
            }
        }
    } // run

} // export